import { BORDER_RADIUS, BUTTON_TOKENS, TYPOGRAPHY } from '../../styles/UISystem';

/**
 * The share-pill treatment — ONE home (extracted at plan 3 Step 10 when
 * THREAD's two sheets needed it and were about to become the third and fourth
 * hand-rolled copy).
 *
 * This is the stacked one-tap row used across every exchange sheet: the host's
 * ShareSheet channel pills, THREAD's venue rows, THREAD's channel selection.
 * A shadowed pill, not a bordered box — the shadow is what makes it read as a
 * control rather than a list item, and it is the same elevation the rest of
 * the app's actions use (BUTTON_TOKENS.ACTION_SHADOW).
 *
 * ONE text size across a sheet (device pass 1, 2026-07-27, user): BODY_REGULAR
 * everywhere so nothing appears to move around between rows.
 */
export const PILL_WIDTH = 260;

export const pillBase = {
  width: `${PILL_WIDTH}px`,
  maxWidth: '100%',
  height: '48px',
  borderRadius: BORDER_RADIUS.PILL,
  border: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  fontSize: TYPOGRAPHY.BODY_REGULAR.fontSize,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  WebkitTapHighlightColor: 'transparent',
};

/** The primary one-tap. */
export const blackPill = (disabled = false) => ({
  ...pillBase,
  backgroundColor: BUTTON_TOKENS.ACTION_BG_PRIMARY,
  boxShadow: BUTTON_TOKENS.ACTION_SHADOW,
  color: BUTTON_TOKENS.ACTION_TEXT_PRIMARY,
  cursor: disabled ? 'default' : 'pointer',
});

/** Every other option in the stack. */
export const whitePill = (disabled = false) => ({
  ...pillBase,
  backgroundColor: '#FFFFFF',
  boxShadow: BUTTON_TOKENS.ACTION_SHADOW,
  color: BUTTON_TOKENS.ACTION_TEXT_SECONDARY,
  cursor: disabled ? 'default' : 'pointer',
});
